import React from 'react';

export default function AboutUsPage() {
  let aboutUs = "Welcome to Accessify, your ultimate online destination for high-quality, stylish, and functional mobile accessories. At Accessify, we understand that in today’s fast-paced world, your mobile device is not just a tool—it’s an essential part of your daily life. From work to play, communication to entertainment, your mobile is always by your side. That’s why we’re dedicated to offering a wide range of accessories that help you make the most of every moment.";


  let ourStory = "Our Story: The Vision Behind Accessify";
  let ourStoryP1 = "At Accessify, we began with a simple mission: to make premium mobile accessories accessible to everyone, no matter where you are or what device you use. Our founders saw an opportunity to create an online store that combined convenience, affordability, and quality, all while providing exceptional customer service. From humble beginnings, Accessify quickly became a trusted name in the mobile accessory market, offering an ever-growing selection of products that cater to every need and preference.";
  let ourStoryP2 = "What started as a small vision has now grown into a thriving brand. Our commitment to excellence, customer-centric approach, and passion for innovation continue to guide us as we expand and improve. Every day, we strive to stay ahead of trends, ensuring that our customers have access to the latest and greatest accessories for their devices.";

  let ourProducts = "Our Products: Curated for Style, Performance, and Durability";
  let ourProductsP1 = "At Accessify, we believe that a great mobile experience goes beyond the device itself. That’s why we offer an extensive selection of accessories designed to enhance your mobile lifestyle. Whether you’re looking to protect, charge, or customize your device, we’ve got you covered. Our categories include:";
  let ourProductsL1 = new Map([
    [
      "Protective Cases & Covers:",
      "We offer a wide variety of cases, from slim and minimalistic to rugged and heavy-duty. Our cases are designed to not only protect your device but also reflect your personal style. Whether you prefer leather, silicone, or tough polycarbonate, you’ll find the perfect fit for your device."
    ],


    [
      "Chargers & Cables:",
      "Fast, reliable charging is essential in today’s world, and our chargers and cables are built with speed and durability in mind. Whether you need a wireless charger, a portable power bank, or a high-quality cable, we’ve got the solutions you need to keep your devices powered up at all times."
    ],


    [
      "Audio Accessories:",
      "Experience audio like never before with our range of wireless earbuds, Bluetooth speakers, and noise-canceling headphones. Whether you’re listening to music, taking calls, or watching movies, our audio accessories offer crystal-clear sound and comfortable, long-lasting wear."
    ],



    [
      "Innovative Gadgets:",
      "Stay ahead of the curve with the latest in mobile accessories and technology. From screen protectors to stylus pens, stands, holders, and car mounts, our innovative gadgets are designed to make your life easier, safer, and more connected."
    ],



    [
      "Smart Wearables:",
      "We also offer a selection of smartwatches and fitness trackers, allowing you to track your health and stay connected in style. Whether you’re tracking steps, monitoring heart rate, or managing notifications, our wearables integrate seamlessly with your lifestyle."
    ]
  ]);
  let ourProductsP2 = "Each of our products is chosen with careful consideration for quality, functionality, and design. We partner with some of the most trusted brands in the industry and constantly seek out the latest innovations to bring to our customers.";


  let ourComitment = "Our Commitment: Quality, Service, and Community";
  let ourComitmentP1 = "At Accessify, we’re not just about selling mobile accessories; we’re about delivering an exceptional customer experience. Our commitment to quality, service, and community is what sets us apart and drives everything we do.";
  let ourComitmentL1 = new Map([
    [
      "Quality Assurance:",
      "We believe that quality matters, which is why every product we sell goes through a rigorous quality control process. We test each accessory for durability, compatibility, and performance, ensuring that it meets our high standards before it reaches you."
    ],
    [
      "Customer-Centric Service:",
      "From browsing our website to receiving your order, our goal is to make your experience as seamless and enjoyable as possible. Our customer support team is available to assist you with any inquiries or issues, ensuring that you feel confident and valued every step of the way."
    ],
    [
      "Fast, Reliable Shipping:",
      "We understand that when you order something, you want it quickly. That’s why we offer fast and reliable shipping, with a variety of delivery options to suit your needs. We take extra care in packaging each item to ensure it arrives in perfect condition, so you can start enjoying your new accessories right away."
    ],
    [
      "Sustainability & Social Responsibility:",
      "We’re committed to doing our part for the planet. Accessify is actively working towards reducing our environmental impact by offering eco-friendly products, reducing waste, and supporting sustainable practices across our operations. We also strive to give back to the community through various charitable initiatives and partnerships."
    ],
  ]);


  let whyAccessify = "Why Choose Accessify?";
  let whyAccessifyP1 = "With so many options available, you may be wondering: What makes Accessify the best choice for your mobile accessories?";
  let whyAccessifyL1 = new Map([
    [
      "Wide Selection:",
      ""
    ],

    [
      "Competitive Prices:",
      "We offer an extensive catalog of products, ensuring that you can find exactly what you need, whether you’re looking for a stylish case, a fast charger, or the latest tech gadget. We’re constantly updating our inventory to reflect the newest trends and innovations in mobile technology."
    ],

    [
      "Easy Online Shopping:",
      "We believe that high-quality accessories should be affordable, which is why we strive to offer the best value without compromising on quality. With Accessify, you can enjoy premium accessories at prices that won’t break the bank."
    ],

    [
      "Trusted by Customers:",
      "Shopping with Accessify is easy, secure, and convenient. Our website is designed to offer a smooth shopping experience, with easy navigation, detailed product descriptions, and secure checkout options. We also provide multiple payment methods to suit your preferences."
    ],

    [
      "Trusted by Customers:",
      "Over the years, Accessify has built a loyal customer base who trust us for our commitment to quality and customer satisfaction. We take pride in the positive feedback we receive and work hard to maintain the trust of our customers."
    ],
  ]);

  let visionFuture = "Our Vision for the Future";
  let visionFutureP1 = "As Accessify continues to grow, our vision remains the same: to be the leading provider of mobile accessories, known for our exceptional products, customer-focused service, and commitment to sustainability. We’re constantly exploring new ways to innovate and improve our offerings, ensuring that we meet the ever-evolving needs of our customers.";
  let visionFutureP2 = "We look forward to continuing this journey with you and providing the accessories that help you stay connected, powered up, and on top of the latest trends.";


  return (
    <div className="w-full p-4">
      <section className="mb-4 flex flex-col sm:flex-row items-center gap-8">
        <div className="flex-1 mb-4 sm:mb-0 flex flex-col justify-start">
          <h1 className="text-3xl font-bold mb-2">About Us</h1>
          <p className="text-light-text-color">{aboutUs}</p>
        </div>
        <div className="flex-1 h-auto flex justify-center items-center">
          <img
            src="/logo512.png"
            alt="Logo"
            className="max-w-full max-h-[300px] w-auto h-auto rounded-lg object-contain"
          />
        </div>
      </section>


      <section className='mb-4'>
        <h1 className="text-3xl font-bold mb-2">{ourStory}</h1>
        <p className="text-light-text-color">{ourStoryP1}</p>
        <p className="text-light-text-color">{ourStoryP2}</p>
      </section>

      <section className='mb-4'>
        <h1 className="text-3xl font-bold mb-2">{ourProducts}</h1>
        <p className="text-light-text-color">{ourProductsP1}</p>
        <ul className='mb-2 mt-2 list-disc'>
          {Array.from(ourProductsL1.entries()).map(([key, value]) => (
            <li key={key}><span className='text-dark-text-color font-bold'>{key}</span> <span className='text-light-text-color'>{value}</span></li>
          ))}
        </ul>
        <p className="text-light-text-color">{ourProductsP2}</p>
      </section>

      <section className='mb-4'>
        <h1 className="text-3xl font-bold mb-2">{ourComitment}</h1>
        <p className="text-light-text-color">{ourComitmentP1}</p>
        <ul className='mb-2 mt-2 list-disc'>
          {Array.from(ourComitmentL1.entries()).map(([key, value]) => (
            <li key={key}><span className='text-dark-text-color font-bold'>{key}</span> <span className='text-light-text-color'>{value}</span></li>
          ))}
        </ul>
      </section>


      <section className='mb-4'>
        <h1 className="text-3xl font-bold mb-2">{whyAccessify}</h1>
        <p className="text-light-text-color">{whyAccessifyP1}</p>
        <ul className='mb-2 mt-2 list-disc'>
          {Array.from(whyAccessifyL1.entries()).map(([key, value]) => (
            <li key={key}><span className='text-dark-text-color font-bold'>{key}</span> <span className='text-light-text-color'>{value}</span></li>
          ))}
        </ul>
      </section>



      <section className='mb-4'>
        <h1 className="text-3xl font-bold mb-2">{visionFuture}</h1>
        <p className="text-light-text-color">{visionFutureP1}</p>
        <p className="text-light-text-color">{visionFutureP2}</p>
      </section>




    </div>
  );
};
